import { useTranslation } from 'react-i18next';

import { useForumUserPosts } from '~/api/forum/useForumUserPosts';
import { useUser } from '~/api/user';

import { ForumPosts } from '../components/ForumPosts';

export const ForumSelfPosts = () => {
  const { data: user } = useUser();
  const query = useForumUserPosts(user.id);

  const { t } = useTranslation(['forum']);

  return (
    <ForumPosts
      emptyMessage={t('forum:overview.selfPosts.empty')}
      errorMessage={t('forum:overview.selfPosts.error.title')}
      page="selfPosts"
      query={query}
    />
  );
};
